// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__BPHP8","lds-ripple":"loader_lds-ripple__oae2g"};